/**
 * Extracts the S3 key from a presigned URL or direct S3 URL
 * @param url - The full presigned URL or direct S3 URL
 * @returns The S3 key path or null if extraction fails
 */
export function extractVideoKey(url: string): string | null {
  try {
    let parsedUrl: URL;
    
    // Handle both absolute and relative URLs
    if (url.startsWith('/')) {
      // Relative URL - add a dummy base
      parsedUrl = new URL(url, 'https://example.com');
    } else {
      parsedUrl = new URL(url);
    }
    
    // Case 1: Direct S3 URL with AWS signature parameters
    if (parsedUrl.hostname === 'activity-holder.s3.amazonaws.com') {
      // Extract the path (everything after the hostname, before query params)
      return parsedUrl.pathname.substring(1); // Remove leading slash
    }
    
    // Case 2: Presigned URL with key parameter
    const keyParam = parsedUrl.searchParams.get('key');
    if (keyParam) {
      // Decode the URL-encoded key
      const decodedKey = decodeURIComponent(keyParam);
      
      // Extract the path after the bucket name (remove the S3 URL prefix and query params)
      const s3UrlMatch = decodedKey.match(/https:\/\/activity-holder\.s3\.amazonaws\.com\/([^?]+)/);
      if (s3UrlMatch) {
        return s3UrlMatch[1];
      }
    }
    
    return null;
  } catch (error) {
    console.error('Error extracting video key:', error);
    return null;
  }
}

/**
 * Extracts video filename from S3 key
 * @param s3Key - The S3 key path
 * @returns The filename or null if extraction fails
 */
export function extractVideoFilename(s3Key: string): string | null {
  try {
    const parts = s3Key.split('/');
    return parts[parts.length - 1] || null;
  } catch (error) {
    console.error('Error extracting video filename:', error);
    return null;
  }
}
